//WebSearchToggle.jsx
import React from 'react';
import { Globe, GlobeLock } from 'lucide-react';
import styles from '../../styles/FileUpload.module.css';

export default function WebSearchToggle({ enabled, onToggle, disabled }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className={`${styles.webSearchButton} ${enabled ? styles.webSearchEnabled : ''}`}
      title={enabled ? "Web search enabled" : "Enable web search"}
    >
      {enabled ? <Globe size={20} /> : <GlobeLock size={20} />}
    </button>
  );
}